"use client"

import styles from "./schedule.module.scss"
import { AppContext } from "../../../../utils/context"
import { useContext } from "react"
import moment from "moment-timezone"

import { CosmosTitle, CosmosText } from "@cosmos/web-react"

import Isack from "../../../../assets/images/graphics/isack.png"

// Returns the HTML markup for the schedule slide
export default function Schedule() {
	// Pull the active event from the context
	const { event } = useContext(AppContext)

	// Return early if there's no event
	if (!event) return null

	// Pull the event sessions from the event
	const { event_sessions } = event

	return (
		<div className={styles.container}>
			<CosmosTitle
				size="xx-large"
				className={styles.title}>
				WEEKEND
				<br />
				SCHEDULE
			</CosmosTitle>

			<img
				src={Isack}
				className={styles.isackImg}
			/>

			<div className={styles.schedule}>
				{event_sessions &&
					event_sessions.map((session, index) => {
						// if a free practice session, remove "Free" from the title
						let sessionLabel = session.session_name
						if (sessionLabel.toLowerCase().includes("free practice")) {
							sessionLabel = sessionLabel.replace("Free ", "")
						} else if (sessionLabel.toLowerCase() === "grand prix") {
							sessionLabel = "Race"
						}

						// get the date as "DD Month"
						// add leading zero to day if needed
						const sessionDate = moment.tz(session.session_times.track.start_time, session.session_times.track.timezone).format("DD MMMM")

						return (
							<div className={styles.session} key={`session_${index}`}>
								<div className={styles.sessionLabel}>
									<CosmosText
										size="small"
										weight="bold">
										{sessionLabel}
									</CosmosText>
								</div>
								<div className={styles.sessionTime}>
									<CosmosText
										weight="bold"
										size="small">
										{moment.tz(session.session_times.track.start_time, session.session_times.track.timezone).format("HH:mm")} -{" "}
										{moment.tz(session.session_times.track.end_time, session.session_times.track.timezone).format("HH:mm")}
									</CosmosText>
								</div>
								<div className={styles.sessionDate}>
									<CosmosText
										weight="bold"
										size="xx-small">
										{sessionDate}
									</CosmosText>
								</div>
							</div>
						)
					})}
			</div>
		</div>
	)
}
